import { render } from "./Batchadd.vue?vue&type=template&id=36ac7e92&scoped=true"
import script from "./Batchadd.vue?vue&type=script&lang=ts"
export * from "./Batchadd.vue?vue&type=script&lang=ts"

import "./Batchadd.vue?vue&type=style&index=0&id=36ac7e92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36ac7e92"

export default script